"use client"

import { Button, Flex, Row, Select } from "antd"
import TextArea from "antd/es/input/TextArea"
const { Option } = Select

const RetractionRequestForm = ({
  notesOptions,
  reasonOptions,
  approveOptions,
  note,
  setNote,
  reason,
  setReason,
  approval,
  setApproval,
  handleRetractRequestForm,
  cancelRetractRequestForm,
  approvalNote,
  setApprovalNote,
  ratype,
}: any) => {
  return (
    <div
      style={{
        padding: "5px",
      }}
    >
      <div className={"bulk-update-container"}>
        <h3 style={{ textTransform: "uppercase", marginBottom: "10px" }}>Bulk Update</h3>
        {ratype === "1" ? (
          <>
            <Row style={{ paddingBottom: "5px", paddingTop: "0px" }}>
              <label>Reason</label>
              <Select
                style={{ width: "100%" }}
                value={reason}
                placeholder="Select Reason"
                // status={detailsSubmitted && !details?.miscInitiatives ? 'error' : ''}
                allowClear
                onChange={(value) => {
                  setReason(value)
                }}
              >
                {reasonOptions.length &&
                  reasonOptions.map((item: any) => (
                    <Option value={item.id} key={item.id}>
                      {item.name}
                    </Option>
                  ))}
              </Select>
            </Row>
            <Row style={{ paddingBottom: "5px", paddingTop: "0px" }}>
              <label>Note</label>
              <Select
                style={{ width: "100%" }}
                placeholder="Select Note"
                value={note}
                allowClear
                // status={detailsSubmitted && !details?.tripLegStatus ? 'error' : ''}
                onChange={(value) => {
                  setNote(value)
                }}
              >
                {notesOptions.length &&
                  notesOptions.map((item: any) => (
                    <Option value={item.id} key={item.id}>
                      {item.name}
                    </Option>
                  ))}
              </Select>
            </Row>
          </>
        ) : (
          <>
            <Row style={{ paddingBottom: "5px", paddingTop: "0px" }}>
              <label>Approval</label>
              <Select
                style={{ width: "100%" }}
                value={approval}
                placeholder="Select Option"
                // status={detailsSubmitted && !details?.miscInitiatives ? 'error' : ''}
                allowClear
                onChange={(value) => {
                  setApproval(value)
                }}
              >
                {approveOptions.length &&
                  approveOptions.map((item: any) => (
                    <Option value={item.id} key={item.id}>
                      {item.name}
                    </Option>
                  ))}
              </Select>
            </Row>
            <Row style={{ paddingBottom: "5px", paddingTop: "0px" }}>
              <label>Note</label>
              <TextArea
                placeholder="Enter Note"
                autoSize={{ minRows: 2, maxRows: 6 }}
                value={approvalNote}
                maxLength={300}
                allowClear
                style={{ width: "100%" }}
                onChange={(e) => setApprovalNote(e.target.value)}
              />
            </Row>
          </>
        )}
      </div>
      <Flex justify="flex-end" style={{ paddingBottom: "1rem", paddingTop: "1rem", background: "#fff" }} gap="small">
        <Button key="applyBulk" onClick={handleRetractRequestForm} style={{ background: "#1677ff", color: "#fff" }}>
          Apply Changes
        </Button>
        <Button
          key="resetBulkDetails"
          onClick={cancelRetractRequestForm}
          style={{ backgroundColor: "#ffffff", borderColor: "#d9d9d9", color: "rgba(0, 0, 0, 0.88)" }}
        >
          Reset
        </Button>
      </Flex>
    </div>
  )
}
export default RetractionRequestForm
